import { motion } from "framer-motion";

// Topographic contour lines — hints at property / land
export const Topo = ({ className = "", stroke = "currentColor" }) => (
  <svg
    className={className}
    viewBox="0 0 600 600"
    fill="none"
    aria-hidden="true"
    preserveAspectRatio="xMidYMid slice"
  >
    <g stroke={stroke} strokeWidth="1.1" opacity="0.5">
      {[...Array(11)].map((_, i) => {
        const s = 40 + i * 24;
        return (
          <path
            key={i}
            d={`M ${300 - s * 1.4} 300
                C ${300 - s * 1.4} ${300 - s}, ${300 - s * 0.4} ${300 - s * 1.5}, 300 ${300 - s * 1.4}
                C ${300 + s * 0.9} ${300 - s * 1.3}, ${300 + s * 1.5} ${300 - s * 0.4}, ${300 + s * 1.4} 300
                C ${300 + s * 1.3} ${300 + s * 0.9}, ${300 + s * 0.5} ${300 + s * 1.5}, 300 ${300 + s * 1.4}
                C ${300 - s} ${300 + s * 1.3}, ${300 - s * 1.4} ${300 + s * 0.6}, ${300 - s * 1.4} 300 Z`}
          />
        );
      })}
    </g>
  </svg>
);

// Rising node network — hints at credit growth / progress
export const GridNetwork = ({ className = "", stroke = "currentColor" }) => (
  <svg className={className} viewBox="0 0 600 400" fill="none" aria-hidden="true">
    <g stroke={stroke} opacity="0.35" strokeWidth="1">
      {[...Array(9)].map((_, c) =>
        [...Array(6)].map((_, r) => (
          <circle key={`${c}-${r}`} cx={40 + c * 65} cy={40 + r * 60} r="2.2" fill={stroke} stroke="none" />
        ))
      )}
    </g>
    <motion.path
      d="M 40 330 L 170 280 L 300 220 L 430 140 L 560 60"
      stroke={stroke}
      strokeWidth="2.5"
      fill="none"
      initial={{ pathLength: 0 }}
      whileInView={{ pathLength: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
    />
    <circle cx="560" cy="60" r="6" fill={stroke} />
  </svg>
);
